const caseid = (caseType) => {
    
    var id_init = Math.round(Math.random() * 1000000).toString();
    
    const len = id_init.length
    
    var prefix = null 
    var output = null

    switch(caseType) {
        case "lead":
            prefix = "LD-"
        break;

        case "support":
            prefix = "SP-"
        break;
        
        default:
        break;
    }
    
    switch(len) {
        case 6:
            output = `${prefix}${id_init}`
        break;
        
        case 5:
            output = `${prefix}0${id_init}`  
        break;
        
        case 4:
            output = `${prefix}00${id_init}`  
        break;

        case 3:
            output = `${prefix}000${id_init}`  
        break;

        case 2:
            output = `${prefix}0000${id_init}`  
        break;
        
        case 1:
            output = `${prefix}00000${id_init}`  
        break;

        default:
        break;
    }

    console.log("post processing:", output)

    return(output)
}

export default caseid